import React from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { DSButton } from '@elliemae/ds-legacy-button-v1';

const ToolbarItem = ({ icon, ...otherProps }) => {
  const displayIcon = React.cloneElement(icon, { size: 'm' });
  return <DSButton {...otherProps} buttonType="text" icon={displayIcon} size="m" />;
};

ToolbarItem.displayName = 'ToolbarItem';

const props = {
  /** toolbar item icon */
  icon: PropTypes.element.description('Toolbar item icon'),
};

ToolbarItem.displayName = 'ToolbarItem';
const DSToolbarItemWithSchema = describe(ToolbarItem);

DSToolbarItemWithSchema.propTypes = props;

// export default ToolbarItem;

export { DSToolbarItemWithSchema, ToolbarItem };
